import { AxiosResponse } from 'axios';
import BaseAPI from "../api";

const path: string = "/advisor";

export type listType = {
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  limit?: number;
  page?: number;
  keyword?: string;
  search?: string;
  id_faculty?: string;
  advisorTypeId?: number;
};

export class advisorApi extends BaseAPI {
  static getAllAdvisor(query?: listType, token?: string): Promise<AxiosResponse> {
    if (!token) {
      return this.api.get(`${path}`, {
        params: { ...query },
      });
    } else {
      return this.api.get(`${path}`, {
        params: { ...query },
        headers: { Authorization: `Bearer ${token}` },
      });
    }
  }

  static getRequestConsultationAdvisorStudent(query?: listType): Promise<any> {
    return this.api.get(`${path}/request/advisor-student`, {
      params: { ...query },
    });
  }

  static getAdvisorById(id: number): Promise<any> {
    return this.api.get(`${path}/${id}/find-one`);
  }

  static getAdvisorRequestByUserLogin(query?: listType): Promise<AxiosResponse> {
    return this.api.get(`${path}/request`, {
      params: { ...query },
    });
  }

  static createAdvisor(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static updateAdvisor(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deleteAdvisor(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }

  static getAdvisorRequestById(id: number, query?: listType): Promise<any> {
    return this.api.get(`${path}/${id}/request`, {
      params: { ...query },
    });
  }

  static getRequestConsultationAdvisorStudentById(
    id: number,
    query?: listType
  ): Promise<any> {
    return this.api.get(`${path}/${id}/request/advisor-student`, {
      params: { ...query },
    });
  }

  static getDownloadAdvisorRequestById(
    id: number,
    query?: listType
  ): Promise<any> {
    return this.api.get(`${path}/${id}/request/download`, {
      params: { ...query },
      responseType: "arraybuffer",
    });
  }

  static getDownloadAdvisorStudentRequestById(
    id: number,
    query?: listType
  ): Promise<any> {
    return this.api.get(`${path}/${id}/request/advisor-student/download`, {
      params: { ...query },
      responseType: "arraybuffer",
    });
  }
  static getDownloadAdvisorStudentRequestByIdAndAdvisor(
    query?: listType
  ): Promise<any> {
    return this.api.get(`${path}/request/advisor-student/download`, {
      params: { ...query },
      responseType: "arraybuffer",
    });
  }


  // E_THE_SIS
  static advisorUpdateNameWithEtheSis(id_advisor_request: number, body: { advisor_request_name: string }): Promise<AxiosResponse> {
    return this.api.patch(`${path}/request-name/${id_advisor_request}`, body)
  }
}
